import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Header from '../common/Header';
import plusIcon from '../../images/icons/plus_icon.svg';
import SubHeader from '../common/SubHeader';
import SearchBar from '../common/SearchBar';
import ButtonComponent from '../common/ButtonComponent';
import ComponentsTable from './ComponentsTable';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import VesselGroupTable from './VesselGroupTable';

const PPE = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [modal, setModal] = useState(false);
  const [search, setSearch] = useState('');
  const [mode, setMode] = useState('add');

  const policies = returnPolicies();

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(resetVendorFilter());
  }, []);
  useEffect(() => {
    if (policies?.ppePolicies.canAccess === false) {
    history.push('/');
  }
}, [policies]);

  const tabChange = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      setSearch('');
    }
  };
  return (
    <>
    {policies?.ppePolicies.canAccess && (
      <div className="md:w-full">
        <Header
        parentPageLink="/"
        currentPage="PPE"
        headerName="PPE"
        />
        <div className="manning-wrapper">
          <SubHeader
            searchComponent={<SearchBar handleSearch={(value) => setSearch(value)} search={search} placeholder="Search (Minimum 3 Characters)" />}
            addButtonComponent={
              activeTab === 1 && policies?.ppePolicies.canEdit ? (
                <ButtonComponent
                  name="Add Component"
                  icon={plusIcon}
                  handleClick={() => {
                    setModal(true);
                    setMode('add');
                  }}
                />
              )
              : activeTab === 0 && policies?.ppePolicies.canEdit && (
              <ButtonComponent
              name="Add New Group"
              icon={plusIcon}
              handleClick={() => {
                setModal(true);
                setMode('add');
              }}
              />
               )
            }
          />
          <div className="flex justify-between items-left full component-table-outline">
            <ul className="flex justify-between text-base text-gray-500 font-bold">
              <li
                className="cursor-pointer px-8 border-none rounded-t-xl text-center pt-1"
                style={{ backgroundColor: activeTab === 0 ? '#F8B113' : '#F1F1F1' }}
                onClick={() => tabChange(0)}
              >
                Vessel Group
              </li>
              <li
                className="cursor-pointer px-8 border-none rounded-t-xl text-center pt-1"
                style={{ backgroundColor: activeTab === 1 ? '#F8B113' : '#F1F1F1' }}
                onClick={() => tabChange(1)}
              >
                Components
              </li>
            </ul>
          </div>
          {activeTab === 0
          ? (
           <VesselGroupTable
          search={search}
          modal={modal}
          policies={policies}
          setModal={setModal}
          mode={mode}
          setMode={setMode}
           />
            )
          : (
          <ComponentsTable
            policies={policies}
            search={search}
            modal={modal}
            setModal={setModal}
            mode={mode}
            setMode={setMode}
          />
)}
        </div>
      </div>
      )}
    </>
  );
};

export default PPE;
